import { atom } from "recoil";

const makeStateAtom = atom({

    key:"makeState",
    default: null

});

export default makeStateAtom;